<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <authors-table />
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable */
import AuthorsTable from "./components/AuthorsTable.vue";

export default {
  name: "tables",
  components: {
    AuthorsTable,
    
  },
  data() {
    return {

    };
  },
  mounted () {
    var user = window.localStorage.getItem('$logged_user');
    if (user != 'admin')
      this.$router.push('/')
  }
};
</script>
